import React from 'react'
import ToggleCurrency from './toggleCurrency/ToggleCurrency'
import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import { Typography, Stack, useMediaQuery } from '@mui/material'
import { Colors } from '../styles/theme'
import { useTheme } from '@mui/material/styles'

function replaceLastChar(str, char) {
    // Find the last index of the character
    const lastIndex = str.lastIndexOf(char)

    // If the character is not found, return the original string
    if (lastIndex === -1) {
        return str
    }

    // Replace the character at the found index
    return str.substring(0, lastIndex) + ' and ' + str.substring(lastIndex + 1)
}

export default function BomGridTotal({
    orderTotal,
    isDesktopDisplay,
    bomLineItems,
    isCAD,
    setIsCADCurrency,
}) {
    // const gridRowSx = isDesktopDisplay ? gridRowDesktopSx : gridRowMobileSx
    // console.log(`In BomGridTotal`)

    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.down('md'))

    const notIncludedReport = `Note, does not include the required:`
    let theRpt = bomLineItems
        .filter((a) => a.sugRetail === '$0.00')
        .reduce((acc, productRow) => {
            //when N/A report on how many screws needed.

            let q = ''
            q = productRow.itemQty === 1 ? ` a ` : productRow.itemQty
            // if (
            //     productRow.productIDNum === '404' ||
            //     productRow.productIDNum === '405'
            // ) {
            //     q =
            //         productRow.itemQty === 1
            //             ? ` 1 bag of 50 screws`
            //             : ` ${productRow.itemQty} bags of 50 screws`
            // } else {
            //     q = productRow.itemQty === 1 ? ` a ` : productRow.itemQty
            // }

            const rowRpt = `${q}       ${productRow.descriptionTitle}`

            return acc.concat(rowRpt)
        }, [])
    theRpt = theRpt.join(`, `)
    theRpt = replaceLastChar(theRpt, `, `)
    // let devMode = true // hard fix on whether CAD is shown - will use only when up and running.
    let theShortageInventoryMessage = ``
    // let theShortageInventoryMessage = `.  We are very sorry. We're temporarily out of Copper Lead Out Wire.  It should only be a matter of days before our restocking.`

    return (
        <Grid2
            container
            columns={20}
            sx={{
                borderTop: 1,
                borderColor: 'black',
                borderBottom: 2,
                py: 0.75,
            }}
        >
            <Grid2 xs={10}>
                <Typography
                    variant="body2"
                    color={`${Colors.companyColors.accent}`}
                    sx={{
                        pl: isDesktopDisplay ? 2 : 1,
                        // py: 0.75,
                        textAlign: 'left',
                        fontStyle: 'italic',
                        fontWeight: 600,
                        pt: { xs: 1.5, sm: 1.5 },
                        pb: { xs: 1, sm: 1.5 },
                        fontSize: '102%',
                        pr: 1,
                        // textShadow: ' 0.05px 0.05px 0.05px #000',
                    }}
                >
                    {notIncludedReport} {theRpt} {theShortageInventoryMessage}
                </Typography>
            </Grid2>
            <Grid2
                xs={10}
                sx={{
                    pl: { xs: 0, lg: 5 },
                }}
            >
                <Stack
                    // direction={{ xs: 'columns', md: 'row' }}
                    justifyContent={'flex-end'}
                    alignItems={matches ? 'flex-end' : 'flex-start'}
                    direction={matches ? 'column' : 'row'}
                    // direction={'column'}
                    flex="1"
                    sx={{ py: { sm: 2 } }}
                >
                    <ToggleCurrency
                        isCAD={isCAD}
                        setIsCADCurrency={setIsCADCurrency}
                    />

                    <Typography
                        variant="h6"
                        sx={{
                            pr: isDesktopDisplay ? 2 : 1,
                            // py: 0.75,
                            textAlign: 'right',
                        }}
                    >
                        {' '}
                        {`Materials Total:     ${orderTotal}`}
                    </Typography>
                </Stack>
            </Grid2>
        </Grid2>
    )
}
